import Vue from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';
import vuetify from './plugins/vuetify';

// firebase
import { auth } from '@/firebase';

Vue.config.productionTip = false;

let app = '';

auth.onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      vuetify,
      store,
      render: (h) => h(App),
    }).$mount('#app');
  }
});

// new Vue({
//   store,
//   router,
//   vuetify,
//   render: (h) => h(App),
// }).$mount('#app');
